const translations = {
  "en": {
    "Answers that remember your history": "Answers that remember your history",
    "Ed already is.": "Ed already is.",
    "Flags risks before they hit": "Flags risks before they hit",
    "Someone should watching the market for you.": "Someone should watching the market for you.",
    "Tracks your holdings while you're away": "Tracks your holdings while you're away"
  },
  "zh-tw": {
    "Answers that remember your history": "答覆會記住你的歷史紀錄",
    "Ed already is.": "Ed 已經是了。",
    "Flags risks before they hit": "在問題發生前標示風險",
    "Someone should watching the market for you.": "應該有人為你盯著市場。",
    "Tracks your holdings while you're away": "在你離開時追蹤你的持倉"
  }
};

export default translations;
